module.exports = __webpack_public_path__ + "static/img/kh-9.48936bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kh-9.png
// module id = Qd+k
// module chunks = 4